import React from 'react'
import PropTypes from 'prop-types'
import {Text, Stack, Box, Divider} from '@salesforce/retail-react-app/app/components/shared/ui'
import BonusProgress from './bonusProgress'

const Header = ({
    title,
    subTitle,
    body,
    bonuses,
    totalSelectedBonuses,
    bonusItemsInBasketArray,
    maxBonusItems,
    promotionDetails
}) => {
    return (
        <Stack gap={{base: '10px', xs: '30px', md: '26px', lg: '20px'}}>
            <Box>
                {title && (
                    <Text
                        color="black"
                        fontSize={{base: '23px', xs: '30px', md: '29px', lg: '30px'}}
                        fontFamily="cormorant"
                        fontWeight="400"
                        lineHeight="normal"
                        letterSpacing={{
                            base: '0.15px',
                            xs: '0.15px',
                            md: '0.145px',
                            lg: '0.115px'
                        }}
                    >
                        {title}
                    </Text>
                )}

                {subTitle && (
                    <Text
                        marginTop={{base: '4px', xs: '2px'}}
                        color="black"
                        fontFamily="cormorant"
                        fontSize={{base: '16px', xs: '23px'}}
                        fontWeight="400"
                        lineHeight="normal"
                        letterSpacing={{base: '0.08px', xs: '0.115px'}}
                    >
                        {subTitle}
                    </Text>
                )}

                {body && (
                    <Text
                        marginTop="10px"
                        color="black"
                        fontSize="13px"
                        fontFamily="body"
                        fontWeight="300"
                        lineHeight="22px"
                        letterSpacing="0.065px"
                    >
                        {body}
                    </Text>
                )}
            </Box>

            {bonuses?.length > 1 ? (
                <BonusProgress
                    totalSelectedBonuses={totalSelectedBonuses}
                    bonusItemsInBasketArray={bonusItemsInBasketArray}
                    promotionDetails={promotionDetails}
                    maxBonusItems={maxBonusItems}
                />
            ) : (
                <Divider borderColor="gray.500" />
            )}
        </Stack>
    )
}

Header.propTypes = {
    title: PropTypes.string,
    subTitle: PropTypes.string,
    body: PropTypes.string,
    bonuses: PropTypes.array,
    promotionDetails: PropTypes.any,
    totalSelectedBonuses: PropTypes.number,
    bonusItemsInBasketArray: PropTypes.any,
    maxBonusItems: PropTypes.number
}

export default Header
